module.exports = __webpack_public_path__ + "static/media/selectArrowUp.c4e30293.svg";